<template>
  <div class="swiper-card card-dashboard">
    <h1>{{ slide.title }}</h1>

    <DashboardTrack v-if="isVisible" @swiperUpdate="swiperUpdate" :focus="getDialFocus" />

    <!-- <div class="summary" v-if="showSummary">
      <transition-group name="fade-slide-bottom" tag="div">          
        <template v-for="step in summarySequence">
          <div
            v-if="step.type === 'tracker' && displayedSteps.includes(step.slug)"
            :key="step.slug"
            class="stat-tracker bounce-in"
          >
            <UserTrack :size="120" :progress="progress" :focus="getDialFocus" />
            <span class="message" v-html="$userEngine.getDialReckoner"></span>
          </div>

          <div
            v-if="step.type === 'border' && displayedSteps.includes(step.slug)"
            :key="`border-${step.slug}`"
            class="animated-border"
          ></div>

          <div
            v-else-if="step.type === 'stat' && displayedSteps.includes(step.slug)"
            :key="`stat-${step.slug}`"
            class="summary-item"
          >
            <transition-group name="fade-slide-right" tag="div" class="item-group">
              <div
                :key="`${step.slug}-icon`"
                :class="`${step.slug}-tone icon`"
                class="icon-text bounce-in"
              >
                <base-svg :svg="step.icon" width="20px" />
                <span>{{ getLabel(step.slug) }}</span>
              </div>
              <span
                :key="`${step.slug}-more`"
                class="more bounce-in"
              >
                {{ getReckoner(step.slug) }}
              </span>
            </transition-group>
          </div>
        </template>
      </transition-group>
    </div>


    <transition name="fade-slide-right" v-if="showSummary">
      <div v-show="showHistory && summary.length > 0" class="history stat-tracker bounce-in">
        <div class="row" v-for="item in summary" :key="item.code">
          <div class="summary-image" :class="{'placeholder' : !item.image || item.image === ''}">
            <img v-if="getImage(item)" :src="getImage(item)" :alt="item.name" />
          </div>
          <span>{{ item.name }}</span>
          <span></span>
        </div>
      </div>
    </transition>

    <Lottie ref="lottie" animation="confetti-jump" /> -->
  </div>
</template>

<script>
  import DashboardTrack from '@/components/v5/elements/DashboardTrack.vue';
  // import UserTrack from '@/components/v5/elements/UserTrack.vue';
  // import Lottie from '@/components/v5/Lottie.vue';

  export default {
    data() {
      return {
        isVisible: false,
        // showHistory: false,
        // summarySequence: [],
        // displayedSteps: [],
        // progress: {
        //   time: 0,
        //   topics: 0,
        //   locales: 0
        // },
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      DashboardTrack
      // UserTrack,
      // Lottie
    },

    // mounted() {
    //   this.summarySequence = [];
    //   this.summarySequence.unshift({ type: 'tracker', slug: 'tracker' });
    //   this.slide.summaryItems.forEach((item) => {
    //     this.summarySequence.push({ type: 'border', slug: `border-${item.slug}` });
    //     this.summarySequence.push({ type: 'stat', ...item });
    //   });
    //   this.summarySequence.push({ type: 'border', slug: `border-last` });
    // },

    computed: {
    //   dial() {
    //     return this.$store.getters.getLibraryItem('dial');
    //   },
  
      getDialFocus() {
        return ['time','topics','locales'].includes(this.slide.slug) ? this.slide.slug : null;
      },



    //   showSummary() {
    //     return this.dial?.rings || false;
    //   },

    //   summary() {
    //     return Object.values(this.dial.rings?.[this.slide.slug]?.detail || {})
    //       .sort((a,b) => {
    //         return a.score > b.score ? -1 : 1;
    //       })
    //       .slice(0, 12);
    //   },

    //   summaryItems() {
    //     return this.$userEngine.dialTracks || {};
    //   },
    },

    methods: {
      swiperUpdate() {
        this.$emit('swiperUpdate');
      },

      isUnlocked() {
        return this.$userEngine.dialTrackUnlocked(this.slide.slug);
      },

      // getImage (item) {
      //   if (this.slide.slug == 'locales') {
      //     let sLocale = item.code.toLowerCase();
      //     return `https://nourished.news/r/i/icons/country_flags/2020/png-iso/${sLocale}.png`;
      //   }
      //   return (item.image && item.image !== '') ? item.image : null;
      // },

      // getLabel (slug) {
      //   return this.$userEngine.dialTrackLabel(slug);
      // },

      // getReckoner (slug) {
      //   return this.$userEngine.dialTrackReckoner(slug);
      // },

      // animateSummary() {
      //   this.displayedSteps = [];

      //   const promises = this.summarySequence.map((step, i) => {
      //     return new Promise((resolve) => {
      //       setTimeout(() => {
      //         this.displayedSteps.push(step.slug);
      //         this.$emit('swiperUpdate')
      //         setTimeout(() => {
      //           this.progress[step.slug] = this.summaryItems[step.slug]?.px;
      //           this.EventBus.$emit("device:haptic", 'light');
      //         }, 300)
      //         resolve();
      //       }, i * 600);
      //     });
      //   });

      //   promises.push(
      //     new Promise((resolve) => {
      //       setTimeout(() => {

      //         this.showHistory = true;
      //         this.$emit('swiperUpdate')
      //         resolve();
      //       }, this.summarySequence.length * 600);
      //     })
      //   );

      //   if (!this.$refs.lottie) { return; }

      //   Promise.all(promises).then(() => {
      //     setTimeout(() => {
      //       this.$refs.lottie?.play()
      //     }, 900)
      //   });
      // },

      next() {
        this.$emit('next')
      }
    },
    
    watch: {
      '$route.params.stack': {
        handler(slug) {
          if (slug === this.slide.slug) {
            this.isVisible = true;
            this.$emit('enableNextAction');
          }
        },
        immediate: true,
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .content {
    padding-top: 1rem;

    h1 {
      font-size: 32px;
      text-align: center;
    }

    // .current {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   margin: 1rem 0;
    // }

    // .history {
    //   display: flex;
    //   flex-direction: column;
    //   border-radius: 10px;
    //   border: 1px solid rgba($neutral-400, 0.25);
    //   margin-top: 1.5rem;

    //   .row {
    //     display: flex;
    //     align-items: center;
    //     padding: 1rem;
    //     width: 100%;

    //     &:not(:last-child) {
    //       border-bottom: 1px solid rgba($neutral-400, 0.25);
    //     }

    //     .summary-image {
    //       width: 1.5rem;
    //       height: 1.5rem;
    //       border-radius: 500px;
    //       overflow: hidden;
    //       margin-right: 0.5rem;

    //       img {
    //         width: 100%;
    //         height: 100%;
    //         border-radius: 500px;
    //         object-fit: cover;
    //       }

    //       &.placeholder {
    //         background: rgba($neutral-400, 0.25);
    //       }
    //     }
    //   }
    // }
  }

  // .summary {
  //   width: 100%;

  //   .summary-item {
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     padding: 1rem 1.2rem;
  //     height: 60px;
  //     font-size: 16px;

  //     .more {
  //       color: $neutral-400;
  //     }

  //     .icon {
  //       display: flex;
  //       align-items: center;

  //       svg {
  //         margin-right: 0.5rem;
  //       }
  //     }

  //     .item-group {
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       width: 100%;
  //     }
  //   }

  //   .animated-border {
  //     height: 1px;
  //     width: 100%;
  //     background: rgba($neutral-400, 0.25);
  //     opacity: 0;
  //     transform: translateY(10px);
  //     animation: fade-slide-right 0.6s ease-in-out forwards;
  //   }
  // }

  // .stat-tracker {
  //   display: flex;
  //   align-items: center;
  //   margin-bottom: 1rem;
  //   animation: fade-slide-right 0.6s ease-in-out forwards;

  //   .message {
  //     font-size: 16px;
  //     margin-left: 1rem;
  //     text-align: left;
  //   }
  // }

  // @keyframes fade-slide-right {
  //   from {
  //     opacity: 0;
  //     transform: translateX(50px);
  //   }
  //   to {
  //     opacity: 1;
  //     transform: translateX(0);
  //   }
  // }

  // @keyframes bounce-in {
  //   0% {
  //     transform: translateX(50px) scale(0.9);
  //     opacity: 0;
  //   }
  //   60% {
  //     transform: translateX(-5px) scale(1.05);
  //     opacity: 1;
  //   }
  //   100% {
  //     transform: translateX(0) scale(1);
  //   }
  // }

  // .fade-slide-right-enter-active {
  //   transition: all 0.6s ease-in-out;
  // }
  // .fade-slide-right-enter-from {
  //   transform: translateX(50px);
  //   opacity: 0;
  // }

  // .bounce-in {
  //   animation: bounce-in 0.6s ease-in-out both;
  //   animation-delay: 0.3s;
  // }
</style>